import { SphereTooltip } from "@components/common/sphere-tooltip";
import { BaseGroupProps } from "@custom-types/group-types";
import { useDateTime } from "@hooks/use-date-time";
import { Box, Typography } from "@mui/material";
import { neutral } from "@flat-ui";
import { withEllipsisTwoLines } from "@styles/common-styles";
import { cardProperties } from "@utils/ui-utils";

/** Defines the height for the card */
export const cardMiddleHeight = "90px";

/**
 * Middle section of the group card that shows the group name and creation date.
 */
export function GroupCardMiddle({ group }: BaseGroupProps): JSX.Element {
  const { formatDate } = useDateTime();

  const groupName = <var>{group.name}</var>;

  return (
    <Box
      component="div"
      sx={{
        paddingTop: cardProperties.creationDatePaddingTop,
        paddingBottom: 0,
        paddingX: "14px",
        height: cardMiddleHeight,
      }}
    >
      {/* Creation Date */}
      <Typography
        sx={{
          fontSize: "10px",
          color: neutral[700],
          lineHeight: "24px",
          letterSpacing: "0.1px",
        }}
      >
        Created: <var>{formatDate(group.createdAt)}</var>
      </Typography>

      {/* Group Name */}
      <SphereTooltip title={groupName}>
        <Typography
          gutterBottom
          component="div"
          sx={{
            fontSize: "16px",
            color: neutral[800],
            fontWeight: 600,
            ...withEllipsisTwoLines,
          }}
        >
          {groupName}
        </Typography>
      </SphereTooltip>
    </Box>
  );
}
